import { Box, Grid } from '@material-ui/core';
import * as d3 from 'd3';
import * as React from 'react';
import { formatPercent } from '../../../../../logic/otherUtilities/formatting/formatPercent';
import { ColorPalette } from '../../../Palette/ColorPalette';

export interface PercentageBarItemProps {
  name: string;
  value: number;
  total: number;
  totalRescaling: number;
  palette: ColorPalette;
}

const PercentageBarItem: React.FC<PercentageBarItemProps> = ({
  name,
  value,
  total,
  totalRescaling,
  palette,
}) => {
  // Styling
  const width = total === 0 ? 0 : (value / total) * Math.floor(total / totalRescaling);
  return (
    <React.Fragment>
      <div className="py-1 flex flex-row items-center">
        <Grid container alignItems={'center'}>
          <Grid item>
            <div className="text-sm font-normal">{name}</div>
          </Grid>
          <Grid item xs>
            <div className="flex justify-end items-center">
              <div className="ml-2 text-base font-medium">{d3.format('.0%')(value / total)}</div>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="pt-[2px]">
              <div className="h-3.5 w-full bg-gray-100 rounded-full">
                <div
                  className="h-3.5 rounded-full"
                  style={{
                    backgroundColor: palette.tertiaryScale[1],
                    width: formatPercent(width, 0) + '%',
                  }}
                />
              </div>
            </div>
          </Grid>
          <Grid item xs />
        </Grid>
      </div>
    </React.Fragment>
  );
};

export default PercentageBarItem;
